module.exports = __webpack_public_path__ + "img/hk_feature1.a803eb1f.jpg";